import React, { useState, useRef, useEffect, useCallback } from "react";
import Select from "react-select";
import { FaSearch, FaToggleOn, FaToggleOff, FaSignInAlt, FaTimesCircle, FaCheckCircle, FaExclamationTriangle, FaSpinner, FaFreebsd, FaCommentSlash, FaComment, FaEye, FaMapMarkedAlt, FaBusinessTime, FaUserClock, FaSort, FaSortUp, FaSortDown, FaDownload, FaFileExcel } from "react-icons/fa";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import * as PartnerService from '../../Services/Partner/PartnerService'
import 'react-datepicker/dist/react-datepicker.css';
import { store } from "../../Store/store";
import CommonPagination from "../../Common/CommonPagination";
import { ValidateSalesAdminSwitchUserLogin } from "../../Services/User/UserService";
import { thunk_reset_user, thunk_set_user } from '../../../src/Action/action';
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Check, X } from "lucide-react";
import { LoadingMessage } from "../../Common/CommonVariables";
import Popover from '../../Common/Popper';
import "./SalesAdmin_PartnerListComponent.css"
import * as XLSX from 'xlsx';

const SalesAdmin_PartnerListComponent = (props) => {
  // const { register, handleSubmit, setValue, getValues, formState: { errors }, reset, } = useForm();

  const [filteredPartnerList, setFilteredPartnerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedSearchPartner = useRef();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15); // Set number of items per page

  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'

  const [loggedInExtension, setLoggedInExtension] = useState(null);
  const [showSwitchUserConfirmModal, setShowSwitchUserConfirmModal] = useState(false);
  const [showLoggedInAsUserModal, setShowLoggedInAsUserModal] = useState(false);
  const [loadingSwitch, setLoadingSwitch] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  const getSortedPartners = () => {
    let sorted = [...filteredPartnerList];

    if (sortColumn) {
      sorted.sort((a, b) => {
        let aValue, bValue;
        let aHasValue, bHasValue;

        if (sortColumn === 'mtdVids') {
          // MTD VIDs is a count
          aValue = parseInt(a?.Patient_Visit_s1__r?.TotalSize ?? 0);
          bValue = parseInt(b?.Patient_Visit_s1__r?.TotalSize ?? 0);
          aHasValue = true;
          bHasValue = true;
        } else if (sortColumn === 'lastVisit') {
          // Last Visit is a date - get the latest interaction
          const getLatestCheckInTime = (interactions) => {
            if (!interactions?.Records?.length) return null;
            const latest = interactions.Records.reduce((latest, curr) => {
              if (!curr.MHL_CheckOut_Time__c) return latest;
              if (!latest || new Date(curr.MHL_CheckOut_Time__c) > new Date(latest.MHL_CheckOut_Time__c)) {
                return curr;
              }
              return latest;
            }, null);
            return latest?.MHL_CheckIn_Time__c ? new Date(latest.MHL_CheckIn_Time__c).getTime() : null;
          };
          aValue = getLatestCheckInTime(a.Interactions__r);
          bValue = getLatestCheckInTime(b.Interactions__r);
          aHasValue = aValue !== null;
          bHasValue = bValue !== null;

          // If one has value and other doesn't, put the one with value first
          if (aHasValue && !bHasValue) return -1;
          if (!aHasValue && bHasValue) return 1;
          if (!aHasValue && !bHasValue) return 0;
        } else if (sortColumn === 'nps') {
          // NPS sorting: rank feedback values (Happy > Neutral > Un Happy > None)
          const NPS_ORDER = {
            "Un Happy": 1,
            "Neutral": 2,
            "Happy": 3,
          };

          const getNpsRank = (rec) => {
            if (!rec?.isNPSFeedback) return 0; // no feedback
            const nps = rec?.npsFeedbackData;
            return NPS_ORDER[nps?.MHL_FeedBack__c] || 0;
          };

          aValue = getNpsRank(a);
          bValue = getNpsRank(b);
          aHasValue = true;
          bHasValue = true;
        } else if (sortColumn === 'pp') {
          // PP indicates Partner Portal onboarding status (boolean)
          aValue = a?.IsOnboarded ? 1 : 0;
          bValue = b?.IsOnboarded ? 1 : 0;
          aHasValue = true;
          bHasValue = true;
        }

        if (sortDirection === 'asc') {
          return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
        } else {
          return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
        }
      });
    }

    return sorted;
  };

  const sortedPartners = getSortedPartners();
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentPartners = sortedPartners.slice(indexOfFirstUser, indexOfLastUser);

  const userInfo = store.getState();
  const userData = userInfo?.userData || {};
  const [searchTerm, setSearchTerm] = useState('');
  const [allPartners, setAllPartners] = useState([]);

  const handleSort = (column) => {
    setCurrentPage(1); // Reset to first page when sorting changes
    if (sortColumn === column) {
      // Toggle direction if clicking the same column
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Set new column and default to ascending
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  // Function to handle search
  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
    setCurrentPage(1); // Reset to first page when searching

    if (!searchValue.trim()) {
      // If search is empty, show all partners
      setFilteredPartnerList(allPartners);
      return;
    }

    const filtered = allPartners.filter(partner => {
      const searchLower = searchValue.toLowerCase();

      return (
        partner.Partner_Name?.toLowerCase().includes(searchLower) ||
        partner.Partner_Code?.toLowerCase().includes(searchLower) ||
        partner.Payment_Type?.toLowerCase().includes(searchLower)
      );
    });

    setFilteredPartnerList(filtered);
  };

  const fetchPartnerList = useCallback((email) => {
    setLoading(true)

    PartnerService.GetPartnerListByEmail(email)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setAllPartners(data.Data);
          setFilteredPartnerList(data.Data);
        }
        else {
          setFilteredPartnerList([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {
        setLoading(false)
      });
  }, []);

  const [teamList, setTeamList] = useState([]);
  const [teamSelectQuery, setTeamSelectQuery] = useState('');
  const [teamDropdownOpen, setTeamDropdownOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const teamSelectRef = useRef();

  const [subTeamList, setSubTeamList] = useState([]);
  const [subTeamSelectQuery, setSubTeamSelectQuery] = useState('');
  const [subTeamDropdownOpen, setSubTeamDropdownOpen] = useState(false);
  const [selectedSubTeam, setSelectedSubTeam] = useState(null);
  const subTeamSelectRef = useRef();


  useEffect(() => {
    if(teamList && teamList.length > 0){
      const handleTeamClickOutside = (e) => {
        if (teamSelectRef.current && !teamSelectRef.current.contains(e.target)) {
          setTeamDropdownOpen(false);
        }
      };
      document.addEventListener('click', handleTeamClickOutside);
      return () => document.removeEventListener('click', handleTeamClickOutside);
    }
  }, []);

  useEffect(() => {
    if(subTeamList && subTeamList.length > 0){
      const handleSubTeamClickOutside = (e) => {
        if (subTeamSelectRef.current && !subTeamSelectRef.current.contains(e.target)) {
          setSubTeamDropdownOpen(false);
        }
      };
      document.addEventListener('click', handleSubTeamClickOutside);
      return () => document.removeEventListener('click', handleSubTeamClickOutside);
    }
  }, []);

  const fetchTeamListByEmail = (email) => {
    // setLoading(true)

    PartnerService.GetSalesTeamDetailsByManagerEmail(email)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setTeamList(data.Data);
        }
        else {
          setTeamList([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {
        // setLoading(false)
      });
  };

  const fetchSubTeamListByEmail = (email) => {
    // setLoading(true)

    PartnerService.GetSalesTeamDetailsByManagerEmail(email)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setSubTeamList(data.Data);
          //console.log("Sub Team List", data);
        }
        else {
          setSubTeamList([])
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => {
        // setLoading(false)
      });
  };

  useEffect(() => {
    fetchPartnerList(userData?.EmailId);
    fetchTeamListByEmail(userData?.EmailId);
    // fetchTeamListByEmail('balkrishna.pisal@metropolisindia.com.invalid');
  }, [fetchPartnerList]);

  const ConfirmSwitchLogin = (rec) => {
    let child_roleid
    if (rec.MHL_Payment_Type__c === 'Rolling Advance') {
      child_roleid = 15 //Sales-RA-Admin role id
    }
    else {
      child_roleid = 14 //Sales-CC-Admin role id
    }

    const payload = {
      Parent_UserId: parseInt(userData.UserId),
      Child_RoleId: parseInt(child_roleid),
      Child_Partner_Code: rec.MHL_Client_Code__c,
      Role_Name: userData.Role_Name
    };

    setLoggedInExtension(payload);
  }

  const ValidateCrossUserApiCall = () => {

    ValidateSalesAdminSwitchUserLogin(loggedInExtension)
      .then(({ data }) => {
        if (data.IsSuccess) {
          //debugger;
          // toast.success("Switching user");
          props.dispatch(thunk_reset_user([]));
          props.dispatch(thunk_set_user(data));
          setShowLoggedInAsUserModal(true)
          let counter = 5;
          const interval = setInterval(() => {
            counter -= 1;
            setCountdown(counter);
            if (counter === 0) {
              navigate('/dashboard');
              clearInterval(interval);
              window.location.reload();
            }
          }, 1000);
        } else {
          toast.error(data.ResponseMessage || "Failed to login as partner");
        }
      })
      .catch((error) => { toast.error("Something went wrong"); console.error(error); })
      .finally()
  }

  const NPS_REASON_MAP = {
    MHL_Logistics_assistants_behaviour_and__c: "Logistics pickup and support",
    MHL_Timely_supply_of_material__c: "Timely supply of material",
    MHL_Test_trunaround_time_TAT__c: "Test turnaround time (TAT)",
    MHL_Frequency_of_sales_representative__c: "Frequency of sales representative meetings",
    MHL_Knowledge_and_communication_of__c: "Knowledge and communication of Customer care advisors",
    Query__c: "Query / Complaint resolution quality",
    MHL_Received_bill_invoices_on_time__c: "Received bill / Invoices on time",
  };

  const getLatestInteraction = (interactions) => {
    if (!interactions?.Records?.length) return null;

    return interactions.Records.reduce((latest, curr) => {
      if (!curr.MHL_CheckOut_Time__c) return latest;

      if (
        !latest ||
        new Date(curr.MHL_CheckOut_Time__c) >
        new Date(latest.MHL_CheckOut_Time__c)
      ) {
        return curr;
      }
      return latest;
    }, null);
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);

    return date.toLocaleString("en-IN", {
      // day: "2-digit",
      // month: "2-digit",
      // year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDate = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const exportToExcel = () => {
    if (sortedPartners.length === 0) {
      toast.error("No data to export");
      return;
    }

    try {
      // Prepare data for export
      const exportData = sortedPartners.map((partner) => {
        const latestInteraction = getLatestInteraction(partner.Interactions__r);
        
        return {
          'Partner Code': partner.MHL_Client_Code__c || "-",
          'Partner Name': partner.Name || "-",
          'Payment Type': partner.MHL_Payment_Type__c || "-",
          'Account Type': partner.Account_Record_Type__c || "-",
          'Business Type': partner.MHL_Business_type__c || "-",
          'Organization': partner?.PrimaryOrgName || "-",
          'SBU': partner?.MHL_OrgSBU__c || "-",
          'MTD VIDs': partner?.Patient_Visit_s1__r?.TotalSize ?? "0",
          'Last Visit Date': latestInteraction?.MHL_CheckIn_Time__c ? formatDate(latestInteraction.MHL_CheckIn_Time__c) : "-",
          'Check In Time': formatDateTime(latestInteraction?.MHL_CheckIn_Time__c) || "-",
          'Check Out Time': formatDateTime(latestInteraction?.MHL_CheckOut_Time__c) || "-",
          'Time Spent (mins)': latestInteraction?.MHL_Time_Spent__c ?? "0",
          'Latitude': latestInteraction?.MHL_Latitude1__c || "-",
          'Longitude': latestInteraction?.MHL_Longitude1__c || "-",
          'NPS Feedback': (() => {
            if (!partner.isNPSFeedback) return "-";
            const nps = partner.npsFeedbackData;
            return nps?.MHL_FeedBack__c || "-";
          })(),
          'NPS Comments': (() => {
            if (!partner.isNPSFeedback) return "-";
            const nps = partner.npsFeedbackData;
            return nps?.MHL_NPS_Comments__c || "-";
          })(),
          'Onboarded': partner.IsOnboarded ? "Yes" : "No",
        };
      });

      // Create workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Partner List");

      // Set column widths
      const columnWidths = [
        { wch: 14 }, // Partner Code
        { wch: 20 }, // Partner Name
        { wch: 16 }, // Payment Type
        { wch: 14 }, // Account Type
        { wch: 16 }, // Business Type
        { wch: 16 }, // Organization
        { wch: 12 }, // SBU
        { wch: 12 }, // MTD VIDs
        { wch: 14 }, // Last Visit Date
        { wch: 14 }, // Check In Time
        { wch: 14 }, // Check Out Time
        { wch: 14 }, // Time Spent
        { wch: 14 }, // Latitude
        { wch: 14 }, // Longitude
        { wch: 14 }, // NPS Feedback
        { wch: 30 }, // NPS Comments
        { wch: 12 }, // Onboarded
      ];
      worksheet['!cols'] = columnWidths;

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 10);
      const filename = `Partner_List_${timestamp}.xlsx`;

      // Write the file
      XLSX.writeFile(workbook, filename);
      toast.success("Excel file downloaded successfully!");
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toast.error("Failed to export data to Excel");
    }
  };

  const handleTeamListSelect = (t) => {
    setSelectedTeam(t);
    setTeamSelectQuery(t.Name);
    setTeamDropdownOpen(false);
    setSelectedSubTeam(null);
    setSubTeamSelectQuery('');
    setSubTeamList([]);
    fetchSubTeamListByEmail(t.Email)
    fetchPartnerList(t.Email);
  }

  const handleSubTeamListSelect = (t) => {
    setSelectedSubTeam(t);
    setSubTeamSelectQuery(t.Name);
    setSubTeamDropdownOpen(false);
    fetchPartnerList(t.Email);
  }

  const handleClearFilter = () => {
    setSelectedTeam(null);
    setSelectedSubTeam(null);
    setTeamSelectQuery('');
    setSubTeamSelectQuery('');
    setSubTeamList([]);
    fetchPartnerList(userData?.EmailId);
};

  return (
    <>
      {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
      {/* <CommonContainer heading="Partner List" buttonText="Add Partner" onButtonClick={() => { setNewPartnerShow(true); reset();setSFDCPartnerDetails([]);setPartnerDetails([]) }}> */}
      <CommonContainer heading="Partner List">
        <div className="d-flex align-items-md-center flex-column flex-md-row custom-tablet-view justify-content-between mb-2">
          <div className="d-flex flex-column flex-md-row align-items-center gap-1 w-100">
            
            {/* SELECT DD START */}
            {/* {teamList && teamList.length > 0 && ( */}
            {teamList && teamList.length > 0 && (
              <div className="custom-form-wrapper">
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Search name, email"
                  isSearchable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  options={
                    teamList
                      .filter((t) => {
                        const q = teamSelectQuery.trim().toLowerCase();
                        if (!q) return true;
                        return (
                          (t.Name || '').toLowerCase().includes(q) ||
                          (t.Email || '').toLowerCase().includes(q)
                        );
                      })
                      .slice(0, 50)
                      .map((t) => ({
                        value: t,
                        label: `${t.Name} (${t.Email})`,
                        Name: t.Name,
                        Email: t.Email,
                      }))
                  }
                  onInputChange={(text) => {
                    setTeamSelectQuery(text);
                  }}
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setSelectedTeam(selectedOption.value);
                      handleTeamListSelect(selectedOption.value);
                    } else {
                      setSelectedTeam(null);
                    }
                    setTeamSelectQuery('');
                  }}
                  onMenuOpen={() => setTeamSelectQuery('')}
                  value={
                    selectedTeam
                      ? { value: selectedTeam, label: `${selectedTeam.Name} (${selectedTeam.Email})`, Name: selectedTeam.Name, Email: selectedTeam.Email }
                      : null
                  }
                  getOptionLabel={(option) => `${option.Name} (${option.Email})`}
                  getOptionValue={(option) => option.Email}
                  formatOptionLabel={(option) => (
                    <div style={{ display: "flex", flexDirection: "column", whiteSpace: "normal", wordWrap: "break-word", fontSize: "12px" }}>
                      <strong>{option.Name}</strong>
                      <span style={{ color: "#666" }}>{option.Email}</span>
                    </div>
                  )}
                  styles={{
                    option: (base) => ({
                      ...base,
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      color: "#999",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      lineHeight: "1.2",
                      width: "100%",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </div>
            )}
            {/* SELECT DD END */}

            {/* SELECT SUB TEAM DD START */}
            {/* {subTeamList && subTeamList.length > 0 && ( */}
            {subTeamList && subTeamList.length > 0 && (
              <div className="custom-form-wrapper">
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Search by name, email"
                  isSearchable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  options={
                    subTeamList
                      .filter((t) => {
                        const q = subTeamSelectQuery.trim().toLowerCase();
                        if (!q) return true;
                        return (
                          (t.Name || '').toLowerCase().includes(q) ||
                          (t.Email || '').toLowerCase().includes(q)
                        );
                      })
                      .slice(0, 50)
                      .map((t) => ({
                        value: t,
                        label: `${t.Name} (${t.Email})`,
                        Name: t.Name,
                        Email: t.Email,
                      }))
                  }
                  onInputChange={(text) => {
                    setSubTeamSelectQuery(text);
                  }}
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setSelectedSubTeam(selectedOption.value);
                      handleSubTeamListSelect(selectedOption.value);
                    } else {
                      setSelectedSubTeam(null);
                    }
                    setSubTeamSelectQuery('')
                  }}
                  onMenuOpen={() => setSubTeamSelectQuery('')}
                  value={
                    selectedSubTeam
                      ? { value: selectedSubTeam, label: `${selectedSubTeam.Name} (${selectedSubTeam.Email})`, Name: selectedSubTeam.Name, Email: selectedSubTeam.Email }
                      : null
                  }
                  getOptionLabel={(option) => `${option.Name} (${option.Email})`}
                  getOptionValue={(option) => option.Email}
                  formatOptionLabel={(option) => (
                    <div style={{ display: "flex", flexDirection: "column", whiteSpace: "normal", wordWrap: "break-word", fontSize: "12px" }}>
                      <strong>{option.Name}</strong>
                      <span style={{ color: "#666" }}>{option.Email}</span>
                    </div>
                  )}
                  styles={{
                    option: (base) => ({
                      ...base,
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      fontSize: "14px",
                      color: "#999",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      display: "flex",
                      alignItems: "center",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      lineHeight: "1.2",
                      width: "100%",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </div>
            )}
            {/* SELECT DD END */}

            {teamList && teamList.length > 0 && (
              <button className="btn btn-danger d-flex py-2" title="Clear Filter" onClick={handleClearFilter}>
                <X size={20}/>
              </button>
            )}

            <button
              type="button"
              className="btn custom-sumbitbtn d-flex align-items-center gap-1 custom-partner-export-btn" 
              onClick={exportToExcel}
              title="Download all partner data as Excel file"
            >
              <FaDownload size={12} />
              Excel
            </button>
          </div>
          <div className="search-box custom-partner-search-box" style={{ position: "relative", }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Partner Code, Name, Payment Type"
              ref={selectedSearchPartner}
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              style={{
                width: "320px",
                paddingRight: "35px",
                borderRadius: "5px",
                border: "1px solid #ddd",
              }}
            />
            <button
              type="button"
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
              style={{
                padding: '5px',
                position: "absolute",
                right: "0px",
                height: "35px",
                width: "45px",
                top: "50%",
                borderTopLeftRadius: "0",
                borderBottomLeftRadius: "0",
                transform: "translateY(-50%)",
              }}
              // onClick={fetchUniversalFilterPartnerData}
              onClick={() => handleSearch(searchTerm)}
            >
              <FaSearch />
            </button>

          </div>

        </div>
        <div>
          <div className="table-responsive" >
            <table className="table table-bordered custom-table" >
              <thead>
                <tr>
                  <th style={{ width: '31%' }}> Partner Details </th>
                  {/* <th style={{ width: '10%' }}> Account Type</th> */}
                  <th style={{ width: '10%' }}> Business Type</th>
                  <th style={{ width: '7%' }}> Org</th>
                  <th style={{ width: '7%' }}> SBU</th>
                  <th 
                    style={{ width: '10%', cursor: 'pointer', userSelect: 'none' }} 
                    onClick={() => handleSort('mtdVids')}
                    title="Click to sort"
                  > 
                    MTD VIDs 
                    <span style={{ marginLeft: '5px' }}>
                      {sortColumn === 'mtdVids' ? (sortDirection === 'asc' ? <FaSortUp size={14} /> : <FaSortDown size={14} />) : <FaSort size={14} />}
                    </span>
                  </th>
                  <th 
                    style={{ width: '11%', cursor: 'pointer', userSelect: 'none' }} 
                    onClick={() => handleSort('lastVisit')}
                    title="Click to sort"
                  > 
                    Last Visit 
                    <span style={{ marginLeft: '5px' }}>
                      {sortColumn === 'lastVisit' ? (sortDirection === 'asc' ? <FaSortUp size={14} /> : <FaSortDown size={14} />) : <FaSort size={14} />}
                    </span>
                  </th>
                  <th style={{ width: '7%' }}> Location </th>
                  <th
                    style={{ width: '6%', cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => handleSort('nps')}
                    title="Click to sort"
                  >
                    NPS
                    <span style={{ marginLeft: '5px' }}>
                      {sortColumn === 'nps' ? (sortDirection === 'asc' ? <FaSortUp size={14} /> : <FaSortDown size={14} />) : <FaSort size={14} />}
                    </span>
                  </th>
                  <th
                    style={{ width: '5%', cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => handleSort('pp')}
                    title="Click to sort"
                  >
                    PP
                    <span style={{ marginLeft: '5px' }}>
                      {sortColumn === 'pp' ? (sortDirection === 'asc' ? <FaSortUp size={14} /> : <FaSortDown size={14} />) : <FaSort size={14} />}
                    </span>
                  </th> 
                  <th style={{ width: '9%' }}> Action </th> 
                </tr>
              </thead>
              <tbody className="patient-list-small-font">
                {loading ? (
                    // <tr><td colSpan="9" className="text-center">Loading... It might take up to 30 sec</td></tr>
                    <tr><td colSpan="10" className="text-center text-muted py-2">
                      <FaSpinner className="fa-spin me-2" style={{ fontSize: "1.2rem" }} />
                      <LoadingMessage />
                    </td></tr > 
                  ) : currentPartners.length > 0 ? (
                    currentPartners.map((rec, index) => {
                      const latestInteraction = getLatestInteraction(rec.Interactions__r);
                      return (
                        <tr key={index} className="partner-list-row">
                          <td style={{ textAlign: "left", verticalAlign: "middle", paddingLeft: '15px' }}>
                            <Popover
                              content={
                                <div style={{ textAlign: "left" }}>
                                  <p><strong>Payment Type:</strong> {rec.MHL_Payment_Type__c}</p>
                                  <p><strong>Account Type:</strong> {rec.Account_Record_Type__c}</p>
                                  <p><strong>Business Type:</strong> {rec.MHL_Business_type__c}</p>
                                </div>
                              }
                            >
                              {rec.MHL_Payment_Type__c === "Rolling Advance" && (
                                <><i className="fas fa-battery-full text-success me-1" /> </>
                              )}
                              {rec.MHL_Payment_Type__c === "Credit" && (
                                <><i className="fas fa-credit-card text-success me-1" /> </>
                              )}
                              {rec.MHL_Payment_Type__c === "Cash" && (
                                <><i className="fas fa-money-bill-wave text-warning me-1" /></>
                              )}
                              &nbsp;
                            </Popover>


                            <b>{rec.MHL_Client_Code__c}</b> - {rec.Name}
                          </td>
                          {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec.Account_Record_Type__c} </td> */}
                          <td style={{ textAlign: "left", verticalAlign: "middle" }}> {rec.MHL_Business_type__c} </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec?.PrimaryOrgName || "-"} </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}> {rec?.MHL_OrgSBU__c || "-"} </td>
                          
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            {rec?.Patient_Visit_s1__r?.TotalSize ?? "0"}
                          </td>

                          <td style={{ textAlign: "center", verticalAlign: "middle"}}>
                            <Popover
                              content={
                                <div style={{ textAlign: "left" }}>
                                  <p><strong> Check In Time:</strong> {formatDateTime(latestInteraction?.MHL_CheckIn_Time__c) || "-"}</p>
                                  <p><strong> Check Out Time:</strong> {formatDateTime(latestInteraction?.MHL_CheckOut_Time__c) || "-"}</p>
                                  <p><strong> Time Spent:</strong> {latestInteraction?.MHL_Time_Spent__c ?? "0"} mins </p>
                                </div>
                              }
                            >
                              {latestInteraction?.MHL_CheckIn_Time__c ? <><FaUserClock style={{ color: 'green' }} className="mr-1" size={16} /> {formatDate(latestInteraction?.MHL_CheckIn_Time__c)}</> : "-"}
                              {/* {formatDate(latestInteraction?.MHL_CheckIn_Time__c) || "-"} */}
                            </Popover>
                          </td>
                          
                          <td style={{ textAlign: "center", verticalAlign: "middle", paddingLeft: '0px' }}>
                            <FaMapMarkedAlt
                              style={{
                                cursor: latestInteraction?.MHL_Latitude1__c && latestInteraction?.MHL_Longitude1__c ? "pointer" : "not-allowed",
                                color: latestInteraction?.MHL_Latitude1__c && latestInteraction?.MHL_Longitude1__c ? "green" : "gray",
                              }}
                              size={18}
                              title={
                                latestInteraction?.MHL_Latitude1__c && latestInteraction?.MHL_Longitude1__c
                                  ? "View Last Visit Location"
                                  : "Last Visit Location not available"
                              }
                              onClick={() => {
                                if (!latestInteraction?.MHL_Latitude1__c || !latestInteraction?.MHL_Longitude1__c) return;
                                const lat = latestInteraction.MHL_Latitude1__c;
                                const lng = latestInteraction.MHL_Longitude1__c;
                                const url = `https://www.google.com/maps?q=${lat},${lng}`;
                                window.open(url, "_blank");
                              }}
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            {rec.isNPSFeedback ? (() => {
                              const nps = rec.npsFeedbackData;
                              // const isHappy = nps?.MHL_FeedBack__c === "Happy";

                              const feedbackClass = nps?.MHL_FeedBack__c === "Happy"
                                ? "text-success"
                                : nps?.MHL_FeedBack__c === "Neutral"
                                  ? "text-warning"
                                  : nps?.MHL_FeedBack__c === "Un Happy"
                                    ? "text-danger"
                                    : "";


                              const reasons = Object.entries(NPS_REASON_MAP)
                                .filter(([key]) => nps?.[key])
                                .map(([, label]) => label);

                              return (
                                <Popover
                                  placement="left"
                                  content={
                                    <div style={{ minWidth: 260 }}>
                                      <p>
                                        <strong>Feedback:</strong>{" "}
                                        <span className={feedbackClass}>
                                          {nps.MHL_FeedBack__c}
                                        </span>
                                      </p>

                                      {nps?.MHL_FeedBack__c != "Happy" && reasons.length > 0 && (
                                        <>
                                          <strong>Reasons:</strong>
                                          <ul className="mb-1">
                                            {reasons.map((r, i) => (
                                              <li key={i}>{r}</li>
                                            ))}
                                          </ul>
                                        </>
                                      )}

                                      {nps.MHL_NPS_Comments__c && (
                                        <p className="mb-0">
                                          <strong>Comments:</strong> {nps.MHL_NPS_Comments__c}
                                        </p>
                                      )}
                                    </div>
                                  }
                                >
                                  <FaComment
                                    size={16}
                                    className={feedbackClass}
                                    // color={isHappy ? "green" : "red"}
                                    style={{ cursor: "pointer" }}
                                  // title={`NPS: ${nps.MHL_FeedBack__c}`}
                                  />
                                </Popover>
                              );
                            })() : "-"}
                          </td>

                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            {rec.IsOnboarded ? <FaCheckCircle color="green" size={16} /> : <FaTimesCircle color="red" size={16} />}
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <FaSignInAlt
                              color={rec.IsOnboarded ? "green" : "gray"} // gray when disabled
                              className={` ${rec.IsOnboarded ? "cursor-pointer" : "cursor-not-allowed opacity-50"}`}
                              title={rec.IsOnboarded ? "Login" : "Disabled"}
                              onClick={() => {
                                if (!rec.IsOnboarded) return; // disable click logic
                                ConfirmSwitchLogin(rec);
                                setShowSwitchUserConfirmModal(true);
                              }}
                            />
                          </td>
                        </tr>
                      )
                    })
                   ) : (
                      <tr>
                        <td colSpan="10" className="text-center py-3">
                          No Partner found
                        </td>
                      </tr>
                    )}
              </tbody>
            </table>
          </div>

          {
            sortedPartners.length > itemsPerPage ? (
              <CommonPagination
                pageList={sortedPartners}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
              />
            ) : null}

        </div>
      </CommonContainer >
      {showSwitchUserConfirmModal && loggedInExtension && (
        <div className="modal-backdrop modal-backdrop-switch-user-modal">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog switch-user-modal" role="document">
              <div className="modal-content modal-content-switch-user-modal">
                <div className="modal-body text-white modal-body-switch-user-modal">
                  <div className="modal-title-switch-user-modal">
                    <div className="modal-icon-switch-user-modal">
                      <FaExclamationTriangle size={28} />
                    </div>
                    <h4>Are you sure?</h4>
                    <button className="btn modal-close-btn-switch-user-modal" onClick={() => setShowSwitchUserConfirmModal(false)} aria-label="Close">
                      <X size={20} />
                    </button>
                  </div>
                  <p className="modal-text-switch-user-modal fs-6">
                    You are about to switch to your partner account.
                    Do you want to continue?
                  </p>
                </div>
                <div className="modal-footer-switch-user-modal">
                  <button
                    type="button"
                    className="btn btn-danger modal-btn-danger-switch-user-modal"
                    onClick={() => setShowSwitchUserConfirmModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-light modal-btn-switch-user-modal"
                    onClick={() => {
                      if (loggedInExtension) {
                        ValidateCrossUserApiCall(loggedInExtension);
                        setShowSwitchUserConfirmModal(false);
                      }
                    }}
                    disabled={loadingSwitch}
                  >
                    {loadingSwitch ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Switching...
                      </>
                    ) : (
                      "Switch"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLoggedInAsUserModal && loggedInExtension && (
        <div className="modal-backdrop modal-backdrop-logged-in-as">
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-sm" role="document">
              <div className="modal-content modal-content-logged-in-as">
                <div className="modal-body text-white modal-body-logged-in-as">
                  <div className="success-icon-container">
                    <Check size={42} className="text-success" />
                  </div>
                  <h4 className="modal-title-logged-in">Successfully Logged In as</h4>
                  <div className="login-details">
                    <div className="detail-item">
                      <span className="detail-label">Partner Code</span>
                      <span className="detail-value">{loggedInExtension.Child_Partner_Code}</span>
                    </div>
                    {/* {loggedInExtension.Role_Name && ( */}
                    <div className="detail-item">
                      <span className="detail-label">Role</span>
                      <span className="detail-value">{loggedInExtension.Role_Name}</span>
                    </div>
                    {/* )} */}
                  </div>
                  <p className="mt-3">The page will refresh in {countdown}</p>
                </div>
                {/* <div className="modal-footer-logged-in">
                                    <button type="button" className="btn modal-btn-logged-in-as" onClick={() => setShowLoggedInAsUserModal(false)}>
                                        Continue
                                    </button>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect()(SalesAdmin_PartnerListComponent);